<template>
  <div class="hb-out-open" @click.stop="">
    <wx-open-launch-app
      id="hb-launch-btn"
      class="hb-out-open-button"
      :appid="appid"
      :extinfo="extinfo"
      @launch="handleLaunch"
      @error="handleError"
    >
      <script type="text/wxtag-template">
        <style>
          .btn {
            width: 9999px;
            height: 9999px;
            background-color: red;
            opacity: 0;
          }
        </style>
        <button class="btn">button</button>
      </script>
    </wx-open-launch-app>
  </div>
</template>

<script>
import { executeProtocolOutApp } from '_lib/utils';

export default {
  props: {
    protocol: {
      type: [String, Object],
      default: '',
    },
    pageIdentifier: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      appid: 'wxe8989eb8b38b5c4d',
    };
  },
  computed: {
    extinfo() {
      let protocol = this.protocol;
      if (typeof protocol === 'object') {
        protocol = `heybox://${encodeURIComponent(JSON.stringify(protocol))}`;
      }
      return JSON.stringify({
        protocol,
        open_source: 'wechat',
        page_identifier: this.pageIdentifier,
      });
    },
  },
  methods: {
    // 点击成功之后执行
    handleLaunch(e) {
      // let { extInfo } = e.detail;
      this.$emit('launch:success');
    },
    // 跳转失败，用executeprotocoloutapp拉起
    handleError(err) {
      // 当前场景不支持跳转，或Android上该应用未安装，或iOS上用户在弹窗上点击确认但该应⽤未安装
      executeProtocolOutApp(this.protocol);
      this.$emit('launch:error');
    },
  },
};
</script>

<style lang="less">
.hb-out-open {
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  .hb-out-open-button {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    overflow: hidden;
  }
}
</style>
